import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteSalary = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}salaries/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteSalary;
